import { formatTagLabel } from './tagLabel';

export function normalizeGigTagLabels(rawTags: unknown): string[] {
  if (!Array.isArray(rawTags)) return [];

  const labels = rawTags
    .map((tag) => {
      if (typeof tag === 'string') return formatTagLabel(tag);
      if (typeof tag === 'object' && tag !== null) {
        const record = tag as Record<string, unknown>;
        const label = formatTagLabel(
          (record.name ?? record.tag_name ?? record.label ?? '').toString(),
        );
        return label;
      }
      return '';
    })
    .filter(Boolean);

  return Array.from(new Set(labels));
}
